import * as React from 'react';
import {
	DateInput,
	Edit,
	EditProps,
	NumberInput,
	SimpleForm,
	TextInput
} from 'react-admin';

export const LiveTrainingMessageEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<TextInput step={1} source="content" label="CONTENT"/>
				<DateInput source="date" label="DATE"/>
			</SimpleForm>
		</Edit>
	);
};
